module.exports = __webpack_public_path__ + "img/embarrassed.491c39eb.svg";